import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "./Firebase";
import { signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { ToastContainer, toast } from "react-toastify";
import ReCAPTCHA from "react-google-recaptcha";
import "react-toastify/dist/ReactToastify.css";
import logoautentificare from "../componente/imagini/logoautentificare.png";
import "./stiluri/PaginaAutentificare.css";

const PaginaAutentificare = ({ onLogin, setUserEmail }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [attempts, setAttempts] = useState(0);
  const [loading, setLoading] = useState(false); // loader
  const recaptchaRef = useRef(null);
  const RECAPTCHA_ACTIVE = 0; // 0 = dezactivat, 1 = activ


  const MAX_ATTEMPTS = 5;
  const LOCK_TIME = 60000; // 1 minut

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (attempts >= MAX_ATTEMPTS) {
    toast.error("Ai depășit numărul maxim de încercări. Încearcă din nou peste 1 minut.");
    return;
  }

  setLoading(true);

  try {
    if (RECAPTCHA_ACTIVE) {
      if (!recaptchaRef.current) {
        toast.error("ReCAPTCHA nu e încărcată.");
        setLoading(false);
        return;
      }

      const token = await recaptchaRef.current.executeAsync();

      if (!token) {
        toast.error("Te rugăm să confirmi că nu ești robot.");
        recaptchaRef.current.reset();
        setLoading(false);
        return;
      }

      const recaptchaRes = await fetch(
        "https://us-central1-epafa-production.cloudfunctions.net/verifyRecaptcha",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token }),
        }
      );
      const recaptchaData = await recaptchaRes.json();

      if (!recaptchaData.success) {
        toast.error("Verificarea reCAPTCHA a eșuat. Încearcă din nou!");
        recaptchaRef.current.reset();
        setLoading(false);
        return;
      }
    }

    // autentificare Firebase
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;
    const idTokenResult = await user.getIdTokenResult();
    localStorage.setItem("authToken", idTokenResult.token);

    onLogin();
    navigate("/dashboard");
    setAttempts(0);

  } catch (error) {
    console.error("Eroare autentificare:", error);
    if (RECAPTCHA_ACTIVE) recaptchaRef.current?.reset();
    setAttempts((prev) => prev + 1);

    if (attempts + 1 >= MAX_ATTEMPTS) {
      setTimeout(() => setAttempts(0), LOCK_TIME);
    }
    toast.error("Email sau parolă incorectă.");
  } finally {
    setPassword("");
    setLoading(false);
  }
};

  const handleResetPassword = async () => {
    if (!email) {
      toast.warn("Te rugăm să introduci emailul.");
      return;
    }

    try {
      await sendPasswordResetEmail(auth, email);
      toast.success("Email de resetare trimis. Verifică inbox-ul!");
    } catch (error) {
      console.error("Eroare resetare:", error);
      toast.error("A apărut o eroare. Verifică emailul.");
    }
  };

  return (
    <div className="pagina-autentificare">
      <div className="header-text">
        <h1>
          Evidența Persoanelor Adulte Fără Adăpost din <br /> România
        </h1>
      </div>

      <div className="logoautentificare">
        <img src={logoautentificare} alt="Logo" className="logo-img" />
      </div>

      <div className="border-section">
        <h2>Autentificare</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Parolă"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

{RECAPTCHA_ACTIVE ? (
  <div style={{ position: 'absolute', bottom: 0, left: 0 }}>
    <ReCAPTCHA
      sitekey="6LdQu-ArAAAAAL16LAUWHMVlQW_635w0HRUXjC0A"
      size="invisible"
      ref={recaptchaRef}
    />
  </div>
) : null}


          <button type="submit" className="buton-autentificare" disabled={loading}>
            {loading ? "Se încarcă..." : "Autentificare"}
          </button>
        </form>

        <button type="button" className="help-button" onClick={handleResetPassword}>
          Ai uitat parola?
        </button>
      </div>

      <div className="help-section">
        <span>Ai nevoie de ajutor? </span>
        <a
          href="mailto:gurgutadanielv@gmail.com?subject=Ajutor%20la%20autentificare&body=Salut,%20am%20nevoie%20de%20ajutor%20la%20autentificare..."
          className="help-button"
        >
          Apasă aici
        </a>
      </div>

      <ToastContainer
        position="top-center"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </div>
  );
};

export default PaginaAutentificare;
